// Automated uploads are scheduled on the audience's clock, so publish times
// are always shown in Eastern time regardless of the viewer's time zone.
const easternFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/New_York',
  weekday: 'short',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
});

export function formatEastern(value) {
  if (!value) return '';
  return `${easternFormatter.format(new Date(value))} ET`;
}
